import React from 'react';

const EmptyHeader = () => <div style={{ height: '65px' }}></div>;

export default EmptyHeader;
